import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls whether process requests to signup in the new signup docker image
 */
export const NEXTJS_SIGNUP_SPLIT_250311 =
  'NEXTJS_SIGNUP_SPLIT_250311' as SettingConst<
    'NEXTJS_SIGNUP_SPLIT_250311',
    boolean,
    | 'RETAILER'
    | 'RETAILER_HEAD_TAGS'
    | 'VISITOR_WEB'
    | 'VISITOR_WEB_HEAD_TAGS'
    | 'VISITOR_PERF_APP_WEB'
  >;
